import {
  MeClient,
  TaskGroupsClient,
  TaskItemStatus,
} from '@r1-development/resolution-mechanicalturk-api-client';
import { Overlap, Prettify } from './typescript-types';

export enum TaskTypes {
  CreatePackageTaskItem = 'CreatePackageTaskItem',
  CallPayerTaskItem = 'CallPayerTaskItem',
  MailPackageTaskItem = 'MailPackageTaskItem',
  // Payer portal "taskType" is not defined yet.
  // Once we get it, this comment should be removed
  // and/or PayerPortalTaskItem value should be renamed.
  PayerPortalTaskItem = 'PayerPortalTaskItem',
  ManualPortalTaskItem = 'ManualPortalTaskItem',
  ReviewTaskItem = 'ReviewTaskItem',
}

export type GetTaskGroupsParamsOriginal = Parameters<
  TaskGroupsClient['getTaskGroups']
>;
export type GetMyTaskGroupsParamsOriginal = Parameters<
  MeClient['getMyTaskGroupsV2']
>;
export type GetMyAvailableTaskGroupsParamsOriginal = Parameters<
  MeClient['getMyAvailableTaskGroups']
>;

export interface GetTaskGroupsParams {
  filterBySpecializations?: boolean;
  limit?: number;
  continuationToken?: string;
  status?: TaskItemStatus[];
  assignedTo?: string[];
  completedBy?: string;
  sort?: string[];
  completedSince?: Date;
  workflowInstanceId?: string;
  taskIds?: string[];
  taskTypes?: string[];
  searchTerm?: string;
  taskStatus?: TaskItemStatus[];
  assigned?: boolean | null;
}

export interface GetMyTaskGroupsParams {
  limit?: number;
  includeUnassigned?: boolean;
  continuationToken?: string;
  sort?: string[];
  status?: TaskItemStatus[];
  searchTerm?: string;
  completedSince?: Date;
  workflowInstanceId?: string;
  taskTypes?: string[];
  assigned?: boolean | null;
}

export type TaskGroupsApiParamsIntersection = Prettify<
  Overlap<GetTaskGroupsParams, GetMyTaskGroupsParams>
>;

export interface GetMyAvailableTaskGroupsParams {
  sort?: string[];
  searchTerm?: string;
  taskTypes?: string[];
  limit?: number;
  continuationToken?: string;
}
